/*
 * @Descripttion:
 * @Author: sjq
 * @Date: 2021-01-25 13:42:19
 * @LastEditors: voanit
 * @LastEditTime: 2021-07-03 17:05:33
 */
import permissionData from '@/store/modules/permission'
import store from '@/store'

export const permission = {
  inserted(el, binding) {
    const { value } = binding
    const roles = store.getters && store.getters.roles
    if (value) {
      const activeName = value
      const hasPermission = roles?.some(role => {
        return activeName === role.menuCode
      })
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`按钮权限配置举例：v-permission="createOrder"`)
    }
  }
}
